import { Instagram, Mail, Menu } from "lucide-react";

interface SiteChromeProps {
  onOpenMenu: () => void;
}

export function SiteChrome({ onOpenMenu }: SiteChromeProps) {
  return (
    <header className="site-chrome">
      <a className="brand" href="#top" aria-label="Jan Husband home">
        <span>Jan Husband</span>
      </a>
      <nav className="desktop-nav" aria-label="Primary navigation">
        <a href="#gallery">Gallery</a>
        <a href="#about">About</a>
      </nav>
      <div className="header-actions">
        <a
          className="icon-button social-action"
          href="https://www.instagram.com/jan_husband_art/"
          aria-label="Instagram"
          target="_blank"
          rel="noreferrer"
        >
          <Instagram aria-hidden="true" />
        </a>
        <a className="nav-action" href="#contact" aria-label="Enquire about paintings and commissions">
          <Mail aria-hidden="true" />
          <span>Enquire</span>
        </a>
      </div>
      <button className="icon-button mobile-menu" type="button" onClick={onOpenMenu} aria-label="Open menu">
        <Menu aria-hidden="true" />
      </button>
    </header>
  );
}
